import { nanoid } from 'nanoid';
import { BrowserStorageService, InMemoryStorageService } from '@empathyco/x-storage-service';
/**
 * Default implementation for the {@link SessionService}.
 *
 * @public
 */
export class DefaultSessionService {
    constructor(storageService = typeof localStorage !== 'undefined'
        ? new BrowserStorageService(localStorage, 'x')
        : new InMemoryStorageService(), ttlMs = 1800000 // 30m * 60s * 1000 = 1800_000ms
    ) {
        this.storageService = storageService;
        this.ttlMs = ttlMs;
    }
    /**
     * Returns the session id of the storage.
     *
     * @returns The current session id.
     *
     * @public
     */
    getSessionId() {
        var _a;
        const sessionId = (_a = this.storageService.getItem(DefaultSessionService.SESSION_ID_KEY)) !== null && _a !== void 0 ? _a : nanoid();
        this.storageService.setItem(DefaultSessionService.SESSION_ID_KEY, sessionId, this.ttlMs);
        return sessionId;
    }
    /**
     * Removes the session if from the storage.
     *
     * @public
     */
    clearSessionId() {
        this.storageService.removeItem(DefaultSessionService.SESSION_ID_KEY);
    }
}
/**
 * Session id key to use as key in the storage.
 *
 * @public
 */
DefaultSessionService.SESSION_ID_KEY = 'session-id';
/**
 * Global instance of the {@link SessionService}.
 */
DefaultSessionService.instance = new DefaultSessionService();
//# sourceMappingURL=session.service.js.map